module.exports = __webpack_public_path__ + "static/media/main idea.ea9a30dd.mp3";